import { SNAPSHOT_TIPO } from '../services/saldosService';

const toMillis = (ts) => {
    if (!ts) return 0;
    if (typeof ts.toMillis === 'function') return ts.toMillis();
    if (ts instanceof Date) return ts.getTime();
    return new Date(ts).getTime();
};

/*
 * Reconstruye los snapshots del día a partir de la proyección por comitente
 * (`saldosComitente`, escrita por la Cloud Function onSaldosSnapshotCreated).
 * Es el modo productor: no puede leer `saldosSnapshots` (un solo documento con
 * todos los comitentes), así que el snapshot se rearma desde sus propios docs.
 *
 * Cada doc lleva el snapshotId del que salió; si durante una re-proyección
 * conviven docs de dos snapshots, se devuelven ambos ordenados por hora y
 * getSnapshotActivo se queda con el último, igual que en modo staff.
 *
 * La proyección solo guarda el snapshot activo, así que el inicial del día se
 * reconstruye aparte desde los campos `saldoInicialDia*` que la función estampa
 * en cada doc: es lo que permite medir la variación del día en el dashboard.
 * El resultado tiene la misma forma que en modo staff: [inicial, ..., activo].
 */
export const buildSnapshotsDesdeProyeccion = (docs, fechaHoy) => {
    const porSnapshot = new Map();
    const iniciales = new Map();
    docs.forEach(d => {
        if (d.fecha !== fechaHoy || !d.snapshotId) return;
        if (!porSnapshot.has(d.snapshotId)) {
            porSnapshot.set(d.snapshotId, {
                id: d.snapshotId,
                fecha: d.fecha,
                tipo: d.tipo,
                uploadedAt: d.uploadedAt,
                comitentes: [],
            });
        }
        porSnapshot.get(d.snapshotId).comitentes.push({
            nroComitente: d.nroComitente,
            nombre: d.nombre,
            saldoARS: Number(d.saldoARS) || 0,
            saldoUSD: Number(d.saldoUSD) || 0,
            saldoCable: Number(d.saldoCable) || 0,
            titulosA3: Array.isArray(d.titulosA3) ? d.titulosA3 : [],
        });

        // Si el activo es el inicial ya quedó armado arriba; si la proyección es
        // anterior a estos campos, no hay apertura que reconstruir.
        if (!d.snapshotInicialId || d.snapshotInicialId === d.snapshotId) return;
        if (!iniciales.has(d.snapshotInicialId)) {
            iniciales.set(d.snapshotInicialId, {
                id: d.snapshotInicialId,
                fecha: d.fecha,
                tipo: SNAPSHOT_TIPO.INICIAL,
                uploadedAt: d.snapshotInicialAt || null,
                comitentes: [],
            });
        }
        iniciales.get(d.snapshotInicialId).comitentes.push({
            nroComitente: d.nroComitente,
            nombre: d.nombre,
            saldoARS: Number(d.saldoInicialDiaARS) || 0,
            saldoUSD: Number(d.saldoInicialDiaUSD) || 0,
            saldoCable: Number(d.saldoInicialDiaCable) || 0,
            titulosA3: [],
        });
    });
    return [...iniciales.values(), ...porSnapshot.values()]
        .sort((a, b) => toMillis(a.uploadedAt) - toMillis(b.uploadedAt));
};
